/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Table, Form, Grid, Button, Pagination, Loader } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { read, write } from "xlsx";
import ReactDOM from "react-dom";
import Strings from "./utilities/StringSelector";
import Constants from "./utilities/Constants";
import Utils from "./utilities/Utils";

const ipRegex = new RegExp("^[0-2][0-9.]*$");
const macRegex = new RegExp("^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$");

const logListBeginMultiplier = 50;
const logListEndMultiplier = 49;

const UtilsInstance = new Utils();
var cameFromLiveListClick = false;
var shouldPaintRowWithGreyColor = true;

class EventLog extends Component {

  // Intialize this component state with an empty log list
  constructor(props) {
    super(props);
    this.state = {
      startTime: "",
      formInput: "",
      originalLogList: [],
      activeLogList: [],
      filteredLogList: [],
      currentPage: 1,
      isLoadingActive: false
    };
  }

  showLoading = () => this.setState({ isLoadingActive: true })
  hideLoading = () => this.setState({ isLoadingActive: false })

  handleIPSearch = () => {
    const len = this.state.originalLogList.length;
    const searchedLogEntries = [];

    for (let i = 0; i < len; i++) {
      if (this.state.originalLogList[i].ip === this.state.formInput) {
        searchedLogEntries.push(this.state.originalLogList[i]);
      }
    }
    // Show all entries that matched the IP on the form or none
    if (searchedLogEntries.length > 0) {
      this.setState({ filteredLogList: searchedLogEntries }, () => {
        this.buildAndRenderPagination(this.state.filteredLogList.length);
        this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
      });
    } else {
      this.setState({ filteredLogList: [] }, () => {
        this.buildAndRenderPagination(this.state.filteredLogList.length);
        this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
      });
    }
  }

  handleMacAddressSearch = () => {
    const len = this.state.originalLogList.length;
    const searchedLogEntries = [];

    for (let i = 0; i < len; i++) {
      if (this.state.originalLogList[i].mac.toUpperCase().indexOf(this.state.formInput.toUpperCase()) !== -1) {
        searchedLogEntries.push(this.state.originalLogList[i]);
      }
    }
    // Show all entries that matched the MAC on the form or none
    if (searchedLogEntries.length > 0) {
      this.setState({ filteredLogList: searchedLogEntries }, () => {
        this.buildAndRenderPagination(this.state.filteredLogList.length);
        this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
      });
    } else {
      this.setState({ filteredLogList: [] }, () => {
        this.buildAndRenderPagination(this.state.filteredLogList.length);
        this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
      });
    }
  }

  handleNameAndTypeSearch = () => {
    const len = this.state.originalLogList.length;
    const searchedLogEntries = [];

    for (let i = 0; i < len; i++) {
      let product_name = (this.state.originalLogList[i].product_name === null) ? "" : this.state.originalLogList[i].product_name;
      
      // Uppercases both strings before comparison to allow search flexibility
      if (product_name.toUpperCase().indexOf(this.state.formInput.toUpperCase()) !== -1) {
        searchedLogEntries.push(this.state.originalLogList[i]);
      }
      else if (this.state.originalLogList[i].type.toUpperCase().indexOf(this.state.formInput.toUpperCase()) !== -1) {
        searchedLogEntries.push(this.state.originalLogList[i]);
      }
    }
    // Show entries that matched the name on the form or none
    if (searchedLogEntries.length > 0) {
      this.setState({ filteredLogList: searchedLogEntries }, () => {
        this.buildAndRenderPagination(this.state.filteredLogList.length);
        this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
      });
    } else {
      this.setState({ filteredLogList: [] }, () => {
        this.buildAndRenderPagination(this.state.filteredLogList.length);
        this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
      });
    }
  }

  // Refreshes the page
  handleRefreshButtonClick = () => {
    this.setState({ filteredLogList: [], currentPage: 1, formInput: "" }, () => {
      document.getElementById("inputform").value = "";
      this.retrieveData();
    });
  }

  /*
    Saves the form input to the component state everytime the user
    types something in the form
  */
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  /*
    Handles user form submit 
    Filters the page list showing only the devices that match the
    ip, mac, product name or type
  */
  handleSubmit = () => {
    // Before doing any searches we empty the filtered log list and set
    // the current page to 1 to avoid problems
    this.setState({ filteredLogList: [], currentPage: 1 }, () => {
      if (this.state.formInput !== "" && ipRegex.test(this.state.formInput)) {
        this.handleIPSearch();
      }
      else if (this.state.formInput !== "" && macRegex.test(this.state.formInput)) {
        this.handleMacAddressSearch();
      }
      else if (this.state.formInput !== "") {
        this.handleNameAndTypeSearch();
      }
      else if (this.state.formInput === "") {
        this.buildAndRenderPagination(this.state.originalLogList.length);
        this.buildAndRenderActiveLogPage(this.state.currentPage);
      }
      else {
        alert(Strings.INSERT_VALID_LOG_INPUT);
      }
    });
  }

  retrieveData = () => {
    this.showLoading();
    fetch(Constants.REQUEST_IP_ADDRESS + "startTime", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({ startTime: (data.startTime) }, () => {
        // Retrieve paginated log
        fetch(Constants.REQUEST_IP_ADDRESS + "log", { mode: "cors" })
          .then(res => res.json())
          .then(data => this.setState({ originalLogList: data }, () => {
            this.hideLoading();
            this.buildAndRenderPagination(data.length);
            this.buildAndRenderActiveLogPage(this.state.currentPage);
          }));
      }));
  }

  formatTime = (logEntry) => {
    if (logEntry.ntp !== null && logEntry.ntp === true) {
      let parsedMillis = Date.parse(logEntry.time);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString(Strings.DATE_LOCALE);
    }
    else if (logEntry.time !== undefined && logEntry.time !== null) {
      const eventTimeInMillis = logEntry.time * 1000;
      const uptimeInMillis = this.state.startTime * 1000;
      const timeNow = new Date().getTime();
      const time = timeNow - uptimeInMillis + eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString(Strings.DATE_LOCALE));
    }
    else {
      return Strings.BEFORE_MONITOR_INIT_STR;
    }
  }

  formatCSVTime = (logEntry, startTime) => {
    if (logEntry.ntp !== null && logEntry.ntp === true) {
      let parsedMillis = Date.parse(logEntry.time);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString(Strings.DATE_LOCALE);
    }
    else if (logEntry.time !== undefined && logEntry.time !== null) {
      const eventTimeInMillis = logEntry.time * 1000;
      const uptimeInMillis = startTime * 1000;
      const timeNow = new Date().getTime();
      const time = timeNow - uptimeInMillis + eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString(Strings.DATE_LOCALE));
    }
    else {
      return Strings.BEFORE_MONITOR_INIT_STR;
    }
  }

  /*
    Each page will show a maximum of 50 log entries
  */
  buildAndRenderPagination = (numOfLogEntries) => {
    // The number of pages should be the highest integer number after (log entries / 50)
    const numOfPages = Math.ceil(numOfLogEntries / 50);
    const pagination = <Pagination
      firstItem={null}
      lastItem={null}
      boundaryRange={1}
      defaultActivePage={this.state.currentPage}
      siblingRange={1}
      totalPages={numOfPages}
      onPageChange={this.handlePageChange} />;
    // eslint-disable-next-line react/no-deprecated
    ReactDOM.render(pagination, document.getElementById("pagination-container"));
  }

  handlePageChange = (e, { activePage }) => {
    this.setState({ currentPage: activePage }, () => {
      // If the user came from a livelist click or has filtered the log
      if (cameFromLiveListClick || this.state.filteredLogList.length > 0) {
        this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
      }
      else {
        this.buildAndRenderActiveLogPage(this.state.currentPage);
      }
    });
  }

  buildAndRenderActiveLogPage = (activePageNumber) => {
    const listBeg = (activePageNumber - 1) * logListBeginMultiplier;         // Multiples of 50 (starting with 0)
    const listEnd = listBeg + logListEndMultiplier;                          // Multiples of 49 (49, 89, 129...)
    const listSize = this.state.originalLogList.length;
    const listToShow = [];

    for (let i = listBeg; i <= listEnd; i++) {
      // If the list size has not been reached yet
      if (i < listSize) {
        listToShow.push(this.state.originalLogList[i]);
      }
      // If the list element === undefined
      else {
        break;
      }
    }
    this.setState({ activeLogList: listToShow }, () => {
      let myDiv = document.getElementById("main-table-container");
      myDiv.scrollTop = 0;
    });
  }

  buildAndRenderActiveFilteredLogPage = (activePageNumber) => {
    const listBeg = (activePageNumber - 1) * logListBeginMultiplier;         // Multiples of 50 (starting with 0)
    const listEnd = listBeg + logListEndMultiplier;                          // Multiples of 49 (49, 89, 129...)
    const listSize = this.state.filteredLogList.length;
    const listToShow = [];

    for (let i = listBeg; i <= listEnd; i++) {
      // If the list size has not been reached yet
      if (i < listSize) {
        listToShow.push(this.state.filteredLogList[i]);
      }
      // If the list element === undefined
      else {
        break;
      }
    }
    this.setState({ activeLogList: listToShow }, () => {
      let myDiv = document.getElementById("main-table-container");
      myDiv.scrollTop = 0;
    });
  }

  /*
    Adjusts the size of the table so that it does not excced the
    browser window height limit
  */
  adjustTableMaxHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    let newTableMaxHeight = browserHeight * Constants.SCALING_FACTOR_LOG;
    newTableMaxHeight = newTableMaxHeight.toString();
    newTableMaxHeight = newTableMaxHeight.concat("px");
    document.getElementById("main-table-container").style["maxHeight"] = newTableMaxHeight;
  }

  // Returns a table row corresponding to the information contained in the log entry
  getLogEntryTableRow = (logEntry) => {
    let tableRow = "";

    // If the row background needs to be painted grey, get it painted
    if (shouldPaintRowWithGreyColor) {
      tableRow = <Table.Row style={paintedTableRowStyle} key={logEntry.id}>
        <Table.Cell verticalAlign="middle">{this.formatTime(logEntry)}</Table.Cell>
        <Table.Cell verticalAlign="middle">{logEntry.ip}</Table.Cell>
        <Table.Cell verticalAlign="middle">{this.getMacValue(logEntry)}</Table.Cell>
        <Table.Cell verticalAlign="middle">{this.getProductNameValue(logEntry)}</Table.Cell>
        <Table.Cell verticalAlign="middle">{logEntry.type}</Table.Cell>
        <Table.Cell verticalAlign="middle" textAlign="left" width="5">{logEntry.description}</Table.Cell>
      </Table.Row>;
    }
    // otherwise, get it with a white background
    else {
      tableRow = <Table.Row key={logEntry.id}>
        <Table.Cell verticalAlign="middle">{this.formatTime(logEntry)}</Table.Cell>
        <Table.Cell verticalAlign="middle">{logEntry.ip}</Table.Cell>
        <Table.Cell verticalAlign="middle">{this.getMacValue(logEntry)}</Table.Cell>
        <Table.Cell verticalAlign="middle">{this.getProductNameValue(logEntry)}</Table.Cell>
        <Table.Cell verticalAlign="middle">{logEntry.type}</Table.Cell>
        <Table.Cell verticalAlign="middle" textAlign="left" width="5">{logEntry.description}</Table.Cell>
      </Table.Row>;
    }

    shouldPaintRowWithGreyColor = !shouldPaintRowWithGreyColor;
    return (tableRow);
  }

  getMacValue = (logEntry) => {
    if (logEntry.type === "IP duplicado") {
      let splitArray = logEntry.mac.split("/");
      return (
        splitArray.map(mac => (
          <span key={mac}>{mac} <br /></span>
        ))
      );
    }
    else {
      return logEntry.mac;
    }
  }

  getProductNameValue = (logEntry) => {
    if (logEntry.type === "IP duplicado") {
      let splitArray = logEntry.product_name.split("/");
      return (
        splitArray.map(product_name => (
          <span key={product_name}>{product_name} <br /></span>
        ))
      );
    }
    else {
      return logEntry.product_name;
    }
  }

  exportLogAsCSV = async () => {
    let startTime = await fetch(Constants.REQUEST_IP_ADDRESS + "startTime", { mode: "cors" })
      .then(res => res.json())
      .then(data => data.startTime);

    let log = await fetch(Constants.REQUEST_IP_ADDRESS + "log", { mode: "cors" })
      .then(res => res.json())
      .then(data => data);

    let csvText = Strings.LOG_CSV_HEADER;

    for (let i = 0; i < log.length; i++) {
      let product_name = (log[i].product_name === null) ? "" : log[i].product_name.replace(/,/g, "");

      csvText += this.formatCSVTime(log[i], startTime).replace(/,/g, " ") + ","
        + log[i].ip + ","
        + log[i].mac + ","
        + product_name + ","
        + log[i].type.replace(/,/g, "") + ","
        + log[i].description.replace(/,/g, "") + "\n";
    }
    
    const workbook = read(csvText, { type: "string", raw: true });
    /* Aqui convertemos o workbook para o formato .xlsx */
    const wbout = write(workbook, { bookType: "xlsx", type: "binary" });

    /* Criação do blob e link para download */
    const blob = new Blob([UtilsInstance.s2ab(wbout)], { type: "application/octet-stream" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = Strings.LOG_CSV_EXPORT_NAME;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    this.adjustTableMaxHeight();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.adjustTableMaxHeight, 5000) });
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
  }

  // Render the table containing log entries
  render() {
    const filter = this.state.formInput;

    const activeLogList = this.state.activeLogList.map(logEntry => (
      this.getLogEntryTableRow(logEntry)
    ));

    return (
      <div style={screenStyle}>

        <Grid id="grid-id" columns="equal" textAlign="center" verticalAlign="middle">
          <Grid.Row>

            <Grid.Column>
              <Button
                content={Strings.EXPORT_CSV}
                color="teal"
                onClick={this.exportLogAsCSV} />
            </Grid.Column>

            <Grid.Column>
              <Form style={searchStyle} onSubmit={this.handleSubmit} >
                <Form.Input
                  placeholder={Strings.LOG_INPUT_TEXT_PLACEHOLDER}
                  id="inputform"
                  icon="search"
                  name="formInput"
                  value={filter}
                  onChange={this.handleChange} />
              </Form>
            </Grid.Column>

            <Grid.Column>
              <Button
                floated='right'
                icon="refresh"
                color="teal"
                size="big"
                onClick={this.handleRefreshButtonClick} />
            </Grid.Column>

          </Grid.Row>
        </Grid>

        <Table style={headerMarginStyle} celled fixed singleLine textAlign="center">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>
                {Strings.HORARY}
              </Table.HeaderCell>

              <Table.HeaderCell>
                {Strings.IP}
              </Table.HeaderCell>

              <Table.HeaderCell>
                {Strings.MAC}
              </Table.HeaderCell>

              <Table.HeaderCell>
                {Strings.PRODUCT_NAME}
              </Table.HeaderCell>

              <Table.HeaderCell>
                {Strings.TYPE}
              </Table.HeaderCell>

              <Table.HeaderCell width="5">
                {Strings.EVENT}
              </Table.HeaderCell>
            </Table.Row>

          </Table.Header>
        </Table>

        <div id="main-table-container" style={tableStyle}>
          <Table celled fixed textAlign="center">
            <Table.Body>{activeLogList}</Table.Body>
          </Table>
        </div>

        <div id="pagination-container"></div>

        <Loader size='big' active={this.state.isLoadingActive}>{Strings.LOG_WAITING}</Loader>

      </div>
    );
  }
}

// CSS custom table stylization
const screenStyle = {
  margin: "2vh 2vw",
  textAlign: "center",
};

const headerMarginStyle = {
  marginTop: "16px",
  marginBottom: "8px",
  width: "99%"
};

const tableStyle = {
  overflowY: "scroll",
  marginBottom: "16px"
};

const searchStyle = {
  marginBottom: "8px",
  width: "100%"
};

const paintedTableRowStyle = {
  backgroundColor: "#f6f8fa"
};

export default withRouter(EventLog);
